// import { Box } from '@chakra-ui/react';
// import { useContext, useEffect, useState } from 'react';
// import { Link } from 'react-router-dom';
// import { PrimaryButton } from '../../components/CustomButton';
// import FullPageLoader from '../../components/FullPageLoader';
// import { infoNotifier } from '../../components/NotificationHandler';
// import { AuthContext } from '../../context/authContext';
// import SingleGuest from '../my-estate/components/singleGuest';
// import { EmptyDetails } from '../../components/EmptyDetails';
// import { PROTECTED_PATHS } from '../../app/constants';
// import Container from '../../components/Container';
// import Header from '../../components/Header';
// import { getGuests } from './service';

// export const GuestHistory = () => {
//   const [guests, setGuests] = useState([]);
//   const { userInfo } = useContext(AuthContext);
//   const [loading, setLoading] = useState(true);
//   const { MY_ESTATE } = PROTECTED_PATHS;

//   console.log(guests);
//   const [renderedGuests, setRenderedGuests] = useState(5);
//   const displayedGuests = guests.slice(0, renderedGuests);
//   const handleLoadMore = () => {
//     if (displayedGuests.length >= guests.length)
//       return infoNotifier('You have reached the end of your guest List');
//     setRenderedGuests((prev) => prev + 4);
//   };

//   useEffect(() => {
//     const { userId } = userInfo;
//     getGuests(userId, setLoading, setGuests);
//   }, [userInfo]);

//   if (guests?.length === 0 && !loading) {
//     return <EmptyDetails />;
//   } else {
//     return loading ? (
//       <FullPageLoader />
//     ) : (
//       <Box>
//         <Box shadow='sm'>
//           <Container>
//             <Header />
//           </Container>
//         </Box>
//         <Container>
//           {displayedGuests.map((guest) => (
//             <SingleGuest key={guest._id} {...guest} />
//           ))}
//           <Box textAlign='center' py='10'>
//             <PrimaryButton
//               btnText='load more guests'
//               onClick={handleLoadMore}
//               maxW='75%'
//             />
//           </Box>
//         </Container>
//       </Box>
//     );
//   }
// };

import {
  Box,
  Center,
  Circle,
  Img,
  Input,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Text,
} from '@chakra-ui/react';
import React, { useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { PrimaryButton } from '../../components/CustomButton';
import FullPageLoader from '../../components/FullPageLoader';
import { infoNotifier } from '../../components/NotificationHandler';
import { AuthContext } from '../../context/authContext';
// import { getGuests } from '../my-estate/service';
import { BsArrowLeft } from 'react-icons/bs';
import { PROTECTED_PATHS } from '../../app/constants';
import { getContactList, getGuests } from './service';
import GuestList from './components/GuestList';
import Contacts from './components/Contacts';

export const GuestHistory = () => {
  const [guests, setGuests] = useState([]);
  const { userInfo } = useContext(AuthContext);
  const [loading, setLoading] = useState(true);
  const [contactList, setContactList] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [refresh, setRefresh] = useState(false);
  const { userId } = userInfo;
  const [renderedGuests, setRenderedGuests] = useState(5);
  const displayedGuests = guests.slice(0, renderedGuests);
  const handleLoadMore = () => {
    if (displayedGuests.length >= guests.length)
      return infoNotifier('You have reached the end of your guest List');
    setRenderedGuests((prev) => prev + 4);
  };

  useEffect(() => {
    getGuests(userId, setLoading, setGuests);
    getContactList(userId, setLoading, setContactList);
  }, [userInfo, refresh, userId]);

  return loading ? (
    <FullPageLoader />
  ) : (
    <Box width='100vw' px='5%' pt='5vh' minH='100vh' maxWidth={'460px'}>
      <Box cursor='pointer' pb='15px'>
        <Link to={PROTECTED_PATHS.MY_ESTATE}>
          <BsArrowLeft size={25} />
        </Link>
      </Box>

      <Tabs isFitted variant='unstyled'>
        <TabList gap='1rem'>
          <Tab {...tabStyles}>
            Guest List
            <Circle bg='lightblue' width='30px' height='20px' ml='10px'>
              {guests?.length}
            </Circle>
          </Tab>
          <Tab {...tabStyles}>
            Contacts
            <Circle bg='lightblue' width='30px' height='20px' ml='10px'>
              {contactList?.length}
            </Circle>
          </Tab>
        </TabList>

        <TabPanels>
          <TabPanel>
            <Input
              placeholder='search guest list by name or phone number'
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value.trim())}
              width='100%'
              borderRadius='10px'
            />
            {guests?.length > 0 ? (
              <GuestList
                setRefresh={setRefresh}
                guests={guests}
                searchTerm={searchTerm}
                displayedGuests={displayedGuests}
              />
            ) : (
              <Center flexDirection='column' h='70vh' w='100%'>
                <Img src='/empty.svg' alt='empty' />
                <Text py='5' fontWeight='500' textAlign='center'>
                  You dont have any contact yet, Invite a guest to add contacts
                </Text>
              </Center>
            )}
            {guests?.length > 0 && (
              <Box textAlign='center' py='10'>
                <PrimaryButton
                  btnText='load more guests'
                  onClick={handleLoadMore}
                  maxW='300px'
                />
              </Box>
            )}
          </TabPanel>

          <TabPanel>
            <Input
              placeholder='search contact...'
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              width='100%'
              borderRadius='10px'
            />
            {contactList?.length > 0 ? (
              <Contacts
                setRefresh={setRefresh}
                contactList={contactList}
                searchTerm={searchTerm}
              />
            ) : (
              <Center flexDirection='column' h='70vh' w='100%'>
                <Img src='/empty.svg' alt='empty' />
                <Text py='5' fontWeight='500' textAlign='center'>
                  You dont have any contact yet, Invite a guest to add contacts
                </Text>
              </Center>
            )}
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Box>
  );
};

const tabStyles = {
  _focus: { border: 'none' },
  _selected: {
    color: 'white',
    bg: 'primary',
    height: '35px',
    borderRadius: '5px',
  },
};
